import Vue from 'vue'
import VueRouter from 'vue-router'
import _this from '../main'
import { Loading } from 'element-ui'
import { i18n } from '../lang/index'
import Layouts from '@/components/Layouts.vue'
import { removeCookie, getCookie, removeStationsId, removeEmsId, getToken, removeToken } from '@/utils/auth'
Vue.use(VueRouter)
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}
export const defaultRoutes = [
  {
    path: '/test',
    name: 'Test',
    component: (resolve) => require(['@/views/test/index'], resolve)
  },
  {
    path: '/largeScreenData',
    name: 'LargeScreenData',
    component: () => import('@/views/largeScreenData/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/forgetPwd',
    name: 'ForgetPwd',
    component: () => import('@/views/forgetPwd')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register.vue')
  },
  {
    path: '/privacyAgreement',
    name: 'PrivacyAgreement',
    component: () => import('@/views/privacyAgreement')
  }
]
export const asyncRoutes = [
  {
    path: '/',
    redirect: '/index',
    component: Layouts,
    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import('@/views/index/index'),
        meta: { roles: ['ems:multiStation'] }
      },
      {
        path: '/stationCard',
        name: 'StationCard',
        component: () => import('@/views/stationCard/index'),
        meta: { roles: ['ems:multiStation'] }
      },
      {
        path: '/stationsOverview',
        name: 'StationsOverview',
        component: () => import('@/views/singleStationData/stationsOverview/index'),
        meta: { roles: ['ems:singleStation'] }
      },
      {
        path: '/stationSystem',
        name: 'StationSystem',
        component: () => import('@/views/singleStationData/stationSystem/index'),
        meta: { roles: ['ems:stationSystem'] }
      },
      {
        path: '/stationSystem/energyManage',
        name: 'EnergyManage',
        component: () => import('@/views/singleStationData/stationSystem/energyManage.vue'),
        meta: {
          activeMenu: '/stationSystem',
          roles: ['ems:stationSystem:powerManage:powerControl:view', 'ems:stationSystem:powerManage:anti-overloading:view', 'ems:stationSystem:powerManage:anti-reflux:view']
        }
      },

      {
        path: '/stationSystem/energyManage/addEditStrategy',
        name: 'AddEditStrategy',
        component: () => import('@/views/singleStationData/stationSystem/components/addEditStrategy.vue'),
        meta: {
          activeMenu: '/stationSystem'
        }
      },
      {
        path: '/wiringDiagram',
        name: 'WiringDiagram',
        component: () => import('@/views/singleStationData/wiringDiagram/index')
      },
      {
        path: '/allDeviceMonitor',
        name: 'AllDeviceMonitor',
        component: () => import('@/views/singleStationData/allDeviceMonitor/index'),
        meta: { roles: ['ems:deviceMonitor'] }
      },
      {
        path: '/allDeviceMonitor/operationLog',
        name: 'AllOperationLog',
        component: () => import('@/views/singleStationData/allDeviceMonitor/operationLog.vue'),
        meta: {
          activeMenu: '/allDeviceMonitor'
        }
      },
      {
        path: '/faultWarning',
        name: 'FaultWarning',
        component: () => import('@/views/singleStationData/faultWarning/index'),
        meta: { roles: ['ems:alarm'] }
      },
      {
        path: '/faultWarning2',
        name: 'FaultWarning2',
        component: () => import('@/views/singleStationData/faultWarning2/index'),
        meta: { roles: ['ems:alarm'] }
      },
      {
        path: '/faultWarning/historyAlarm',
        name: 'HistoryAlarm',
        component: () => import('@/views/singleStationData/faultWarning/historyAlarm.vue'),
        meta: {
          activeMenu: '/faultWarning',
          roles: ['ems:alarm']
        }
      },
      {
        path: '/elecPriceManage',
        name: 'ElecPriceManage',
        component: () => import('@/views/singleStationData/elecPriceManage'),
        meta: { roles: ['ems:electrovalence:manage'] }
      },
      {
        path: '/elecPriceManage/addEditTemplate',
        name: 'AddEditTemplate',
        component: () => import('@/views/singleStationData/elecPriceManage/addEditTemplate'),
        meta: {
          activeMenu: '/elecPriceManage',
          roles: ['ems:electrovalence:manage:add', 'ems:electrovalence:manage:edit']
        }
      },
      {
        path: '/elecPriceManage/quoteTemplate',
        name: 'QuoteTemplate',
        component: () => import('@/views/singleStationData/elecPriceManage/quoteTemplate'),
        meta: {
          activeMenu: '/elecPriceManage',
          roles: ['ems:electrovalence:manage:add']
        }
      },
      {
        path: '/elecPriceManage/synchronousTtariff',
        name: 'SynchronousTtariff',
        component: () => import('@/views/singleStationData/elecPriceManage/synchronousTtariff'),
        meta: {
          activeMenu: '/elecPriceManage'
        }
      },
      {
        path: '/workOrder',
        name: 'workOrder',
        component: () => import('@/views/maintenanceManage/workOrder'),
        meta: {
          roles: ['ems:workOrder:manage']
        }
      },
      {
        path: '/alarmMonitor',
        name: 'AlarmMonitor',
        component: () => import('@/views/alarmMonitor/index'),
        meta: {
          roles: ['ems:workOrder:manage']
        }
      },
      {
        path: '/reportPower',
        name: 'ReportPower',
        component: () => import('@/views/reportStatistics/reportPower/index'),
        meta: { roles: ['ems:power:report'] }
      },
      {
        path: '/reportProfit',
        name: 'ReportProfit',
        component: () => import('@/views/reportStatistics/reportProfit'),
        meta: { roles: ['ems:profit:report'] }
      },
      {
        path: '/powerStationManage',
        name: 'PowerStationManage',
        component: () => import('@/views/systemSetting/powerStationManage'),
        meta: { roles: ['ems:station:manage'] }
      },
      {
        path: '/powerStationManage/addEditStation',
        name: 'AddEditStation',
        component: () => import('@/views/systemSetting/powerStationManage/addEditStation'),
        meta: {
          activeMenu: '/powerStationManage',
          roles: ['ems:station:manage:edit', 'ems:station:manage:add']
        }
      },
      {
        path: '/powerStationManage/slaveConfiguration',
        name: 'slaveConfiguration',
        component: () => import('@/views/systemSetting/powerStationManage/slaveConfiguration'),
        meta: {
          activeMenu: '/powerStationManage'
        }
      },
      // {
      //   path: '/powerStationManage/addEditStation',
      //   name: 'AddEditStation',
      //   component: () => import('@/views/systemSetting/powerStationManage/tabAddEdit'),
      //   meta: {
      //     activeMenu: '/powerStationManage',
      //     roles: ['ems:station:manage:edit', 'ems:station:manage:add']
      //   }
      // },
      {
        path: '/stencilManage',
        name: 'StencilManage',
        component: () => import('@/views/systemSetting/stencilManage'),
        meta: {
          roles: ['ems:template:manage']
        }
      },
      {
        path: '/stencilManage/addEditStencil',
        name: 'AddEditStencil',
        component: () => import('@/views/systemSetting/stencilManage/addEditStencil'),
        meta: {
          activeMenu: '/stencilManage',
          roles: ['ems:template:manage:add', 'ems:template:manage:edit']
        }
      },
      {
        path: '/userManage',
        name: 'UserManage',
        component: () => import('@/views/systemSetting/userManage'),
        meta: { roles: ['ems:user:manage'] }
      },
      {
        path: '/systemManage',
        name: 'SystemManage',
        component: () => import('@/views/systemSetting/systemManage/index'),
        meta: { roles: ['ems:emsSystem:manage'] }
      },
      {
        path: '/systemManage/equipmentMonitoring',
        name: 'EquipmentMonitoring',
        component: () => import('@/views/systemSetting/systemManage/equipmentMonitoring'),
        meta: {
          activeMenu: '/systemManage',
          roles: ['ems:deviceMonitor']
        }
      },
      {
        path: '/systemManage/controlConfiguration',
        name: 'ControlConfiguration',
        component: () => import('@/views/systemSetting/systemManage/controlConfiguration'),
        meta: {
          activeMenu: '/systemManage'
        }
      },
      {
        path: '/systemManage/equipmentInput',
        name: 'EquipmentInput',
        component: () => import('@/views/systemSetting/systemManage/equipmentInput'),
        meta: {
          activeMenu: '/systemManage',
          roles: ['ems:emsSystem:manage:device:entry']
        }
      }
    ]
  },
  {
    path: '/dataScreen',
    name: 'DataScreen',
    component: () => import('@/views/dataScreen/index'),
    meta: { roles: ['ems:bigScreen'] }
  },
  {
    path: '/statisticalScreen',
    name: 'StatisticalScreen',
    component: () => import('@/views/dataScreen/worldScreen'),
    meta: { roles: ['ems:bigScreen'] }
  },
  {
    path: '/largeScreen',
    name: 'LargeScreen',
    component: () => import('@/views/dataScreen/huayou'),
    meta: { roles: ['ems:bigScreen'] }
  }
]
const router = new VueRouter({
  routes: [...defaultRoutes, ...asyncRoutes],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})
const whiteList = ['/login', '/register', '/test', '/forgetPwd', '/privacyAgreement', '/largeScreenData']
router.beforeEach((to, from, next) => {
  try {
    window._axiosPromiseArr.forEach((ele, index) => {
      ele.cancel() // 清空（终止）正在请求的内容
      // 清空请求的参数 清空请求的参数
      delete window._axiosPromiseArr[index]
    })
  } catch (e) {}
  let token = getToken('Token')
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      let roles = getCookie('Permission') ? getCookie('Permission').split(',') : []
      if (to.meta.roles) {
        let t = roles.find((item) => to.meta.roles.includes(item))
        if (to.meta.roles && t) {
          next()
        } else {
          removeCookie('config')
          removeCookie('isCollapse')
          removeCookie('UserName')
          removeCookie('Permission')
          removeCookie('setPowerTip')
          removeCookie('setDescTip')
          removeCookie('setProfitTip')
          removeCookie('isCollapse')
          removeStationsId('stationId')
          removeEmsId('emsId')
          removeToken('Token')
          let loadingInstance = Loading.service({
            fullscreen: true,
            text: i18n.t('该账号目前没有资源权限即将返回登录页'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.8)'
          })
          setTimeout(() => {
            loadingInstance.close()
            router.push({ path: '/login' })
          }, 2000)
        }
      } else {
        next()
      }
      // }
    }
  }
})
export default router

// const createRouter = () =>
//   new VueRouter({
//     scrollBehavior() {
//       return { x: 0, y: 0 }
//     },
//     routes: defaultRoutes
//   })
// const router = createRouter()

// export function resetRouter() {
//   hasRoles = true
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher // 重置路由，不同用户菜单权限会有所不同，在切换用户时，会出现菜单错乱的情况
// }

// const whiteList = ['/login', '/register', '/403', '/test', '/forgetPwd', '/powerrivacyAgreement']
// let hasRoles = true
// router.beforeEach(async (to, from, next) => {
//   let token = getCookie('Token')
//   if (whiteList.indexOf(to.path) !== -1) {
//     next()
//   } else {
//     if (!token) {
//       router.push({ path: '/login' })
//     } else {
//       let roles = getCookie('Permission').split(',')
//       const accessRoutes = await store.dispatch('generateRoutes', roles)
//       if (hasRoles) {
//         resetRouter()
//         accessRoutes.forEach(function (route) {
//           router.addRoute(route)
//         })
//         hasRoles = false //解决动态路由刷新问题
//         next({ ...to, replace: true }) // replace: true, 导航中将留下 history 记录
//       } else {
//         next()
//       }
//     }
//   }
// })
// export default router
